import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderAssignmentService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/provider-assignment/store`, data, { headers: this.authService.userToken() });
  }

  getAllByPacient(params): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/provider-assignment/get-all-by-patient?contract_id=${params.contract_id}&ordemservico_id=${params.ordemservico_id}`, { headers: this.authService.userToken() });
  }

  getAllByProvider(id): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/provider-assignment/get-all-by-provider/${id}`, { headers: this.authService.userToken() });
  }

  update(params): Observable<any[]> {
    return this.http.put<any>(`${URL_GLOBAL}/web/provider-assignment/update/${params.id}`, params, { headers: this.authService.userToken() });
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/provider-assignment/destroy/${id}`, { headers: this.authService.userToken() });
  }

}
